import React, { useRef, useState } from 'react';
import { useAuth } from '../components/Auth/AuthContext';
import VendorQueue from '../components/LiveStamping/VendorQueue';
import VendorSampleUpload from '../components/LiveStamping/VendorSampleUpload';
import VendorFinalUpload from '../components/LiveStamping/VendorFinalUpload';

const LiveStampingVendorPortal = () => {
  const { user } = useAuth();
  const queueRef = useRef(null);
  const [activeOrder, setActiveOrder] = useState(null);

  if (!user || (user.role !== 'vendor' && user.role !== 'admin')) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <p className="text-gray-500">Access denied. Vendor account required.</p>
      </div>
    );
  }

  const handleSelectOrder = (order) => setActiveOrder(order);

  const handleUploadSuccess = () => {
    setActiveOrder(null);
    queueRef.current?.refresh();
  };

  const handleCloseModal = () => setActiveOrder(null);

  const getModal = () => {
    if (!activeOrder) return null;
    if (activeOrder.status === 'executing') {
      return (
        <VendorSampleUpload
          order={activeOrder}
          onSuccess={handleUploadSuccess}
          onClose={handleCloseModal}
        />
      );
    }
    if (activeOrder.status === 'compliance_check') {
      return (
        <VendorFinalUpload
          order={activeOrder}
          onSuccess={handleUploadSuccess}
          onClose={handleCloseModal}
        />
      );
    }
    // Non-actionable status — show VendorFinalUpload in read-only/gated mode
    if (['metadata_ready', 'preview_submitted', 'pending_verification'].includes(activeOrder.status)) {
      return (
        <VendorFinalUpload
          order={activeOrder}
          onSuccess={handleUploadSuccess}
          onClose={handleCloseModal}
        />
      );
    }
    return null;
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="h-9 w-9 bg-indigo-100 rounded-lg flex items-center justify-center">
            <svg className="w-5 h-5 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>
          <div>
            <h1 className="text-lg font-bold text-gray-800">Live Stamping — Vendor Queue</h1>
            <p className="text-xs text-gray-500">Logged in as {user.name} ({user.role})</p>
          </div>
        </div>
        <a href="/" className="text-sm text-gray-500 hover:text-gray-700 font-medium">← Back to Dashboard</a>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto p-6">
        <VendorQueue ref={queueRef} onSelectOrder={handleSelectOrder} />
      </div>

      {/* Upload modals */}
      {getModal()}
    </div>
  );
};

export default LiveStampingVendorPortal;
